<template>
    <pause-question :stageId="stageId" :question="$t('PAUSE_DELIVERIES_IF_YOU')" :updateSubscriptionText="$t('PAUSE_DELIVERIES_WOULD_YOU')" v-model="optionSelected" />
</template>

<script>
import { mapGetters } from 'vuex';
import ErrorResponseHandler from '@/helpers/ErrorResponseHandler';
import PreferencesService from '@/services/users/PreferencesService';
import PauseQuestion from '@/components/partials/account/my-delivery-addresses/PauseQuestion';

let preferencesService = new PreferencesService();

export default {
    name: 'WeeklyEmailStep',
    components: { PauseQuestion },
    props: {
        subscriptionId: {
            required: true,
            type: Number,
        },
        pauseSurveyAnswer: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            isNextStepClicked: false,
            optionSelected: null,
            stageId: 'weekly-email',
            errorHandler: new ErrorResponseHandler(),
        };
    },
    computed: {
        ...mapGetters({
            userId: 'account/getUserId',
        }),
        updatedSteps() {
            const currentStepIndex = this.pauseSurveyAnswer.nextSteps.indexOf(this.stageId);
            return this.pauseSurveyAnswer.nextSteps.slice(currentStepIndex + 1);
        },
    },
    watch: {
        optionSelected() {
            if (this.optionSelected === 'update') {
                this.putOnWeeklyEmail();
            } else if (this.optionSelected === 'continue') {
                this.nextStep();
            }
        },
    },
    methods: {
        putOnWeeklyEmail() {
            preferencesService.addUserToWeeklyEmail(this.userId)
                .then(() => this.$emit('subscription-updated'))
                .catch(error => this.errorHandler.setResponse(error.response.data));
        },
        nextStep() {
            this.isNextStepClicked = true;
            this.$emit('input', this.updatedSteps);
        },
    },
};
</script>
